import React, { useState, useEffect } from 'react';

import { useParams } from 'react-router-dom';

import UserDevices from '../../components/Shared/Devices/UserDevices'

import MainBlockContainer from '../MainBlockContainer';
import MainBlockHeader from '../MainBlockHeader'

import { useRecoilValue } from 'recoil';
import { selectedUserState } from '../../states/selectedUserState';
import UserPermissions from '../../services/user.permissions.service';

import { useTranslation } from 'react-i18next';

export default function Devices() {  
  let { userUid, recordUid } = useParams();
  const { t } = useTranslation();
  const user = useRecoilValue(selectedUserState);
  let permissions = new UserPermissions(user);

  //useEffect(() => {   
    
  //}, []);


  return (
    <>              
      <MainBlockHeader header={t('devices.header')} />

      <MainBlockContainer>
        <UserDevices apiDevicesBaseUrl={`/user/${userUid}/devices`} />      
      </MainBlockContainer>
    </>
  );  
}

